import { RUNTIMES, TIBBO_DEVICE_ID } from '@appblocks/platforms/PlatformUtils';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
    SettingType,
    ValidationMessage,
    ValidationMessageType,
    Define,
    SettingState,
    SettingOption,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import * as micropython from './micropython';
import * as tios from './tios';

export default class SNTP extends BaseFeature {
    constructor() {
        super();
        this.name = 'Time (SNTP)';
        this.id = 'sntp';
        this.icon = 'BsClock';
        this.requirements = ['network', 'rtc'];
        this.capabilities = ['time'];

        const settings = [
            {
                id: 'ENABLED',
                name: 'SNTP Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '1',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'DEBUGPRINT',
                name: 'Debug Print',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'SNTP_SERVER',
                name: 'SNTP Server IP',
                settingType: SettingType.IP,
                dataType: TibboDataType.SETTING,
                required: true,
                setting: {
                    SETTINGID: 'SNTPI',
                    NAME: 'SNTP Server IP',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MAX: 16,
                    DEFAULT: '216.239.35.0',
                },
                UIControl: {
                    CONTROL: 'IPCTRL',
                },
                default: '216.239.35.0',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDependencies() {
        if (this.project.runtime === RUNTIMES.TIOS) {
            return [
                'time',
                'sock',
                'datetime',
            ];
        }

        return [
            'time',
            'datetime',
        ];
    }

    getFiles(): string[] {
        if (this.project.runtime === RUNTIMES.TIOS) {
            return [
                'libraries/sntp/sntp.tbh',
                'libraries/sntp/sntp.tbs',
            ];
        }
        if (this.project.runtime === RUNTIMES.MICROPYTHON) {
            return [
                'ntptime.py',
            ];
        }
        return [];
    }

    getState(settingId: string): SettingState {
        if (settingId !== 'ENABLED' && this.getSettingValue('ENABLED').toString() === '0') {
            return SettingState.HIDDEN;
        }
        switch (settingId) {
            case 'ENABLED':
                return SettingState.ENABLED;
            default:
                return SettingState.ENABLED;
        }
    }

    getDefines(): Array<Define> {
        const defines = [];
        if (this.getSettingValue('DEBUGPRINT').toString() === '1') {
            defines.push({
                name: 'SNTP_DEBUG_PRINT',
                value: '1',
            });
        }

        return defines;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return [];
            case 'simulator':
                return [];
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
